import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

type MarketingTab = { id: string, title: string, link: string};

const TABS: MarketingTab[] = [
  { id: 'list', title: 'Campaign List', link: '/marketing-campaigns/list'},
  { id: 'groups', title: 'Groups', link: '/marketing-campaigns/groups'},
  { id: 'history', title: 'History', link: '/marketing-campaigns/history'}
];

@Component({
  selector: 'app-marketing-campaigns',
  templateUrl: './marketing-campaigns.component.html',
  styleUrls: ['./marketing-campaigns.component.scss']
})
export class MarketingCampaignsComponent implements OnInit{
  tabs: MarketingTab[] = TABS;
  activeTab: MarketingTab = TABS[0];

  constructor(
      private router: Router
  ) {
  }

  ngOnInit(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    const urlSegments = parsedUrl.root.children.primary.segments;
    urlSegments.length = 2;
    this.activeTab = this.tabs.find(link => link.link === parsedUrl.toString()) ?? TABS[0];
  }

  gotoTab(tab: MarketingTab): void {
    this.router.navigate([tab.link]).then();
    this.activeTab = tab;
  }
}
